import { createReducer } from "@reduxjs/toolkit";
import {
  getCompletedRAListAsync,
  getRiskAnalysisListSuccess,
  loadingList,
  setProcedureId,
} from "./riskAnalysisQuestionnaireActions";

export interface IRiskAnalysisQuestionnaireState {
  riskAnalysisList: Array<any>;
  completedRiskAnalysisList: Array<any>;
  dataCount: number;
  isLoading: boolean;
  ProcedureId: number;
}

const initialState: IRiskAnalysisQuestionnaireState = {
  riskAnalysisList: [],
  completedRiskAnalysisList: [],
  dataCount: 0,
  isLoading: false,
  ProcedureId: 0,
};

export const riskAnalysisQuestionnaireReducer = createReducer(
  initialState,
  (builder) => {
    builder
      .addCase(getRiskAnalysisListSuccess, (state, action) => {
        state = {
          ...state,
          riskAnalysisList: action.payload?.data,
          dataCount: action.payload?.dataCount,
        };
        return state;
      })
      .addCase(getCompletedRAListAsync, (state, action) => {
        state = {
          ...state,
          completedRiskAnalysisList: action.payload?.data,
          dataCount: action.payload?.dataCount,
        };
        return state;
      })
      .addCase(loadingList, (state, action) => {
        state = {
          ...state,
          isLoading: action.payload,
        };
        return state;
      })
      .addCase(setProcedureId, (state, action) => {
        state = {
          ...state,
          ProcedureId: action.payload,
        };
        return state;
      });
  }
);
